import { gql, useMutation } from "@apollo/client"
import { SCHEDULE_TRIGGER_FIELDS } from "./useQueryTriggers"

const CREATE_SCHEDULE_TRIGGER = gql`
  ${SCHEDULE_TRIGGER_FIELDS}
  mutation CreateScheduleTrigger($input: ScheduleTriggerInput!) {
    createScheduleTrigger(input: $input) {
      ...ScheduleTriggerFields
    }
  }
`

const UPDATE_SCHEDULE_TRIGGER = gql`
  ${SCHEDULE_TRIGGER_FIELDS}
  mutation UpdateScheduleTrigger($id: ID!, $input: ScheduleTriggerInput!) {
    scheduleTrigger(id: $id) {
      update(input: $input) {
        ...ScheduleTriggerFields
      }
    }
  }
`

const useMutationCreateScheduleTrigger = (options) => useMutation(CREATE_SCHEDULE_TRIGGER, options)

const useMutationUpdateScheduleTrigger = (options) => useMutation(UPDATE_SCHEDULE_TRIGGER, options)

export { useMutationCreateScheduleTrigger, useMutationUpdateScheduleTrigger }
